import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, Button } from 'antd';

class LoadingDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      open: props.loading,
      error: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      open: nextProps.loading,
      error: nextProps.error,
    });
  }

  closeDialog() {
    this.setState({ open: false, error: null });
    this.props.cancel();
  }

  render() {
    const { error, open } = this.state;
    const { closeDialog } = this;
    const title = error ? 'Error' : 'Sending record...please wait';
    return (
      <Modal
        title={title}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={closeDialog.bind(this)}
          >
            OK
          </Button>,
        ]}
        visible={error ? true : open}
        onCancel={closeDialog.bind(this)}
        closable={false}
      >
        {
          error ? <p style={{ color: 'red' }}>Error: {error}</p> : null
        }
        { !error ? <p>This should only take a moment </p> : null
        }
      </Modal>
    );
  }
}

LoadingDialog.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

export default LoadingDialog;
